import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "elegant_affairs_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(KEY);
    if (!consent) {
      // Tiny delay so the banner doesn't flash before the page paints
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ accepted: true, ts: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[80] bg-[var(--mn-ink)] text-[var(--mn-bg)] border border-[var(--mn-ink)] shadow-xl fade-up"
      role="dialog"
      aria-label="Cookie notice"
      data-testid="cookie-banner"
    >
      <div className="p-5 md:p-6">
        <p className="eyebrow text-white/60">Privacy notice</p>
        <p className="text-sm leading-relaxed mt-2">
          We use a few essential cookies for your shopping cart and admin sign-in.
          No third-party advertising, no tracking. Read more in our{" "}
          <Link to="/privacy" className="underline decoration-[var(--mn-accent)] underline-offset-4 hover:text-white" data-testid="cookie-privacy-link">
            Privacy Policy
          </Link>.
        </p>
        <div className="mt-4 flex items-center gap-3">
          <button
            onClick={accept}
            className="bg-[var(--mn-bg)] text-[var(--mn-ink)] px-6 py-2.5 uppercase tracking-[0.22em] text-[11px] font-medium hover:bg-white transition-colors"
            data-testid="cookie-accept"
          >
            Got it
          </button>
          <button
            onClick={accept}
            className="p-2 hover:opacity-70"
            aria-label="Dismiss"
            data-testid="cookie-dismiss"
          >
            <X size={16} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </div>
  );
}
